/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import {
  InvestmentCard,
  AnimationContainer,
  Flex,
} from '../../coreui';
import NoInvestments from './NoInvestments';

import reitTooltips from '../../reit/toolTipData';

const InvestmentCards = ({
  investments,
  accreditationRoleStatus,
  gtkySubmittedApproved,
  gtkyApproved,
  emptyText,
  selectedIoType,
}) => {
  return (
    <Flex
      pt={0}
      w={1}
      justify="center"
    >
      <Flex
        wrap="wrap"
        justify="center"
      >
        {
          investments.map(
            (investment, index) => {
              return (
                <InvestmentCard
                  selectedIoType={selectedIoType}
                  zIndex="0"
                  fadeIndex={investment.fadeIndex !== undefined ? investment.fadeIndex : index}
                  gtkyApproved={gtkyApproved}
                  gtkySubmittedApproved={gtkySubmittedApproved}
                  accreditationRoleStatus={accreditationRoleStatus}
                  key={investment.id}
                  id={investment.id}
                  reit={investment.REIT}
                  statusLabel={investment.statusLabel}
                  status={investment.status}
                  eligible1031={investment['1031Eligible']}
                  minimum={investment.minimum}
                  targetHoldMin={investment.targetHoldMin}
                  targetHoldMax={investment.targetHoldMax}
                  blurb={investment.blurb}
                  propertyName={investment.label}
                  investmentTypeDisplay={investment.investmentTypeDisplay}
                  propertyType={investment.propertyType}
                  propertyLocation={investment.propertyLocation}
                  ioLabel={investment.title}
                  payoutLabel={investment.payoutLabel}
                  actualIrr={investment.actualIRR}
                  irrObjective={investment.IRRObjective}
                  returnObjective={investment.returnObjective}
                  actualHold={investment.actualHold}
                  investmentGoal={investment.IRRObjective}
                  fundedDate={investment.escrowCloseDate}
                  completedDate={investment.actualMaturityDate}
                  amountInvested={investment.amountInvested}
                  {...(investment.progressBar ? { progressBar: investment.progressBar } : {})}
                  pathAlias={investment.path}
                  pathProps={investment.pathProps}
                  {...(investment.linkText ? { linkText: investment.linkText } : {})}
                  linkType={investment.linkType || 'to'}
                  imageUrl={investment.image}
                  distribution={investment.lastDistributionDeclared}
                  distributionTooltip={investment.distributionTooltip}
                  {...(investment.REIT ? {
                    payoutTooltip: reitTooltips[investment.id === 193744 ? 'mr1' : 'mr2'].freq,
                  } : {})}
                  watchlist={investment.watchlist}
                  waitlist={investment.isWaitlisted}
                  noAnimate={investment.noAnimate}
                />
              );
            },
          )
        }
        {
          investments.length === 0 && emptyText &&
          <AnimationContainer
            name="fadeIn"
            duration="2.5s"
            fillMode="backwards"
          >
            <NoInvestments emptyText={emptyText} />
          </AnimationContainer>
        }
      </Flex>
    </Flex>
  );
};

InvestmentCards.propTypes = {
  investments: PropTypes.array,
  accreditationRoleStatus: PropTypes.string,
  gtkySubmittedApproved: PropTypes.bool,
  gtkyApproved: PropTypes.bool,
  emptyText: PropTypes.string,
  selectedIoType: PropTypes.string,
};

export default InvestmentCards;
